import { mount } from '../../../js/dom-lifecycle';

mount('.code-editor-pre[data-height]', function () {
    this.style.maxHeight = 'unset';
    this.style.height = this.dataset.height + 'px';
});
